import { useEffect } from 'react';
import { Spinner } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { useGetRCFRepaymentSummary } from 'lendingApi/lendingApiHooks';
import styles from '../../SummaryCard.module.css';

type TProps = {
  offerId: string;
  maxAmount: number;
  offerIsSelected: boolean;
  offerNotSelected: boolean;
  setFormattedRCFWithdrawalFee: (value: string) => void;
};

export const RCFWithdrawalFee = ({
  offerId,
  maxAmount,
  offerIsSelected,
  offerNotSelected,
  setFormattedRCFWithdrawalFee,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();
  const { data, isLoading } = useGetRCFRepaymentSummary(offerId, maxAmount);

  const withdrawalFeeAmount = data?.data?.summary?.total_fees;

  useEffect(() => {
    if (withdrawalFeeAmount) {
      setFormattedRCFWithdrawalFee(formatCurrency(withdrawalFeeAmount));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [withdrawalFeeAmount]);

  if (isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Spinner dataTestId="spinner" />
      </div>
    );
  }

  return (
    <div
      className={clsx(styles.value, {
        [styles.selectedValue]: offerIsSelected,
        [styles.unselectedValue]: offerNotSelected,
      })}
    >
      {withdrawalFeeAmount ? (
        <>
          {formatCurrency(withdrawalFeeAmount)}{' '}
          <span className={styles.valueSubtext}>
            (<Trans>unique</Trans>)
          </span>
        </>
      ) : (
        '-'
      )}
    </div>
  );
};
